import { render, staticRenderFns } from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=template&id=fa89fdb6&scoped=true"
import script from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa89fdb6",
  null
  
)

export default component.exports